export enum TenantDashboardChartId {
    TotalLearners = 'total_learners',
    DailyActiveLearners = 'daily_active_learners',
    LearnersByDeviceType = 'learners_by_device_type',
    LearnerLoginFrequency = 'learner_login_frequency',
    LearnersByGender = 'learners_by_gender',
    TotalAverageLearningTime = 'total_average_learning_time',
    MonthlyActiveLearners = 'monthly_active_learners',
    MonthlyLearningTimeByActiveLearners = 'monthly_learning_time_by_active_learners',
    TopCoursesByActiveLearners = 'top_courses_by_active_learners',
    MonthtlyTotalLearningTime = 'monthtly_total_learning_time',
    GrowDailyActiveUsers = 'grow_daily_active_users',
    GrowDailyPageViews = 'grow_daily_page_views',
    GrowDailyPostingLinkFollowed = 'grow_daily_posting_link_followed',
    GrowPageViewsByUsers = 'grow_page_views_by_users',
    GrowCTR = 'grow_ctr',
    CourseCompletionState = 'course_completion_state',
    PersonalReviewCompletionState = 'personal_review_completion_state',
    MonthlyActiveDays = 'monthly_active_days',
}
